import { render } from "./CoursesForm.vue?vue&type=template&id=a8f61b1a"
import script from "./CoursesForm.vue?vue&type=script&lang=js"
export * from "./CoursesForm.vue?vue&type=script&lang=js"
script.render = render

export default script